import { useCallback } from 'react';
import { useTheme } from '../hooks/useTheme'
import siteConfig from '../config/siteConfig';

export function Footer() {
  const theme = useTheme(state => state.getThemeStyles())
  const getCurrentYear = useCallback(() => {
    return new Date().getFullYear();
  }, []);

  return (
    <footer className={theme.components.footer.wrapper}>
      <div className={theme.components.footer.container}>
        <p className={theme.components.footer.text.base}>
          {siteConfig.footer.copyrightText} © {getCurrentYear()} - Desenvolvido por{' '}
          <a
            href={siteConfig.footer.developerLink}
            target="_blank"
            rel="noopener noreferrer"
            className={theme.components.footer.link}
          >
            {siteConfig.footer.developerName}
          </a>
        </p>
      </div>
    </footer>
  );
} 